import { useMutation, useQueryClient } from '@tanstack/react-query';
import { channelsApi } from '../services';

/**
 * Hook para trocar a engine (Node ↔ Go) de um canal WhatsApp Gateway.
 * Operação destrutiva: encerra a sessão atual e gera novo QR Code.
 *
 * @example
 * const switchEngine = useSwitchEngineChannel();
 * const result = await switchEngine.mutateAsync({ channelId, engine: 'go' });
 * if (result.qrCode) { ... }
 */
export const useSwitchEngineChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ channelId, engine }: { channelId: string; engine: 'node' | 'go' }) =>
      channelsApi.switchEngine(channelId, engine),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['channels'] });
    }
  });
};
